import {getCookie, setCookie, deleteCookie} from '@helpers/cookie';

class StorageToken {
    constructor() {
        this.fieldToken = 'vikon_access_token_profile_applicant';
        this.fieldRefreshToken = 'vikon_refresh_token_profile_applicant';
        if (window.sessionStorage) {
            this.storage = 'localStorage';
        } else if (navigator.cookieEnabled) {
            this.storage = 'cookie';
        } else {
            console.log('не удалось подобрать хранилище для хранения токена');
        }
    }
    getToken() {
        switch (this.storage) {
            case 'localStorage':
                return localStorage.getItem(this.fieldToken);
            case 'cookie':
                return getCookie(this.fieldToken);
        }
    }
    getRefreshToken() {
        switch (this.storage) {
            case 'localStorage':
                return localStorage.getItem(this.fieldRefreshToken);
            case 'cookie':
                return getCookie(this.fieldRefreshToken);
        }
    }
    setToken(token) {
        switch (this.storage) {
            case 'localStorage':
                localStorage.setItem(this.fieldToken, token);
                break;
            case 'cookie':
                setCookie(this.fieldToken, token, {path: '/', 'max-age': 24 * 60 * 60});
                break;
        }
    }
    setRefreshToken(token) {
        switch (this.storage) {
            case 'localStorage':
                localStorage.setItem(this.fieldRefreshToken, token);
                break;
            case 'cookie':
                setCookie(this.fieldRefreshToken, token, {path: '/', 'max-age': 24 * 60 * 60 * 2});
                break;
        }
    }
    removeToken() {
        switch (this.storage) {
            case 'localStorage':
                localStorage.removeItem(this.fieldToken);
                break;
            case 'cookie':
                deleteCookie(this.fieldToken);
                break;
        }
    }
    removeRefreshToken() {
        switch (this.storage) {
            case 'localStorage':
                localStorage.removeItem(this.fieldRefreshToken);
                break;
            case 'cookie':
                deleteCookie(this.fieldRefreshToken);
                break;
        }
    }
}
export default StorageToken;